import { useMemo } from 'react';

import { GetDashboardTbmInfosV1ResponseDto } from 'generated/apiSchemas';
import { GetTbmInfosQueryResult } from 'generated/graphql';

export const useData = (
  data: GetTbmInfosQueryResult['data'],
  pmData: GetDashboardTbmInfosV1ResponseDto | undefined,
) => {
  return useMemo(() => {
    const constructionSite = data?.constructionSite.at(0);
    if (!constructionSite) {
      return null;
    }

    const currentRingNumber = pmData?.ringNumber ?? 0;
    const totalRings = constructionSite?.nbTotalRings ?? null;

    const currentMetricPoint = pmData?.metricPoint ?? 0;
    const totalMeters = constructionSite.nbTotalMeters ?? null;

    const advancement = totalMeters
      ? (currentMetricPoint / totalMeters) * 100
      : 0;
    let percent = advancement;
    if (advancement < 0) {
      percent = 0;
    }
    if (advancement > 100) {
      percent = 100;
    }

    return {
      percent,
      currentRingNumber,
      totalRings,
      currentMetricPoint,
      totalMeters,
    };
  }, [data?.constructionSite, pmData?.metricPoint, pmData?.ringNumber]);
};
